import { all, takeLatest } from 'redux-saga/effects';
import * as shopActions from '../actions';
import fetchTags from './worker.fetchTags';

function* shopSaga() {
  yield all([takeLatest(shopActions.fetchTagsData.type, fetchTags)]);
}

export default shopSaga;
